import { Button, Form, Table, Input, Pagination } from "antd";
import React, { useContext } from "react";
import { PageContext } from "../../../lib/context";
import Loading from "../../../components/loader";

export default function PaymentsPage() {
  const { payments, usersColumns, _onFinishSearch, loading, limit, total, current, handlePaginationChange, handleSort } = useContext(PageContext);

  return (
    <div className="flex flex-col px-10">
      <div className="items-start align-start">
        <p className="text-3xl font-bold">Payments</p>
      </div>
      <div className="mb-5">
        <Form layout="inline" onFinish={_onFinishSearch}>
          <Form.Item name="id">
            <Input
              style={{ width: 320 }}
              placeholder="Search by Billing ID / Customer ID / Customer first name / Customer last name"
              allowClear
              size="large"
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" size="large">
              Search
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="flex flex-row">
        <div className="w-full mr-3">
          {loading ? (
            <div className="mt-32">
              <Loading show={loading} />
            </div>
          ) : (
            <>
              <Table dataSource={payments} columns={usersColumns} pagination={false} onChange={handleSort} />
              <Pagination
                onChange={handlePaginationChange}
                current={current}
                pageSize={limit}
                total={total}
              />
            </>
          )
          }
        </div>
      </div>
    </div>
  );
}
